export default {
  title: "Gráfico de tendencias",
  recent_records: "Registros recientes",
  preview_report: "Vista previa del informe",
  compliant_status_good: "Estado de cumplimiento bueno",
  custom_factor_status: "Usando factor personalizado, estado de cumplimiento pendiente",
  tax_amount: "Monto del impuesto",
  based_on_eur: "Basado en €{amount}",
  total_emission: "Emisión total",
  recent_calculation_date: "Fecha del último cálculo",
  no_records: "Sin registros",
  calculate_now: "Calcular ahora",
  cbam_news: "Noticias CBAM",
  no_news: "Sin noticias",
  usage_stats_and_price: "Estadísticas de uso y precio del carbono",
  monthly_calculation_count: "Número de cálculos mensuales",
  monthly_report_count: "Número de informes mensuales",
  monthly_avg_emission: "Emisión promedio mensual",
  today_carbon_price: "Precio del carbono hoy",
  current_plan: "Plan actual: {plan}",
  upgrade_now: "Actualizar ahora",
  trial_remaining: "{days} días restantes, {calculations} cálculos, {reports} informes",
  expiry_date: "Fecha de vencimiento: {date}",
  free_plan_desc1: "100 cálculos por mes, 1 informe por día",
  free_plan_desc2: "¡Actualice para desbloquear más funciones!",
  trial_expired: "Período de prueba expirado, actualice al plan Pro (99 €/mes) para continuar",
  config_fetch_failed: "Error al obtener la configuración",
};
